import { gql } from '@apollo/client';

export const GET_AI_SEARCH_ENABLED = gql`
  query GetAiSearchEnabled {
    aiSearchEnabled
  }
`;
